import {
  createApiFactory,
  createApiRef,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  identityApiRef,
  microsoftAuthApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { ProductApi, ProductClient } from './api/ProductClient';

export const productApiRef = createApiRef<ProductApi>({
  id: 'plugin.work.item.client',
});

export const productWorkItemPlugin = createPlugin({
  id: 'product-work-item',
  apis: [
    createApiFactory({
      api: productApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
        authApi: microsoftAuthApiRef,
      },
      factory: deps =>
        new ProductClient(deps, '499b84ac-1321-427f-aa17-267ca6975798'),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const ProductWorkItemPage = productWorkItemPlugin.provide(
  createRoutableExtension({
    name: 'ProductWorkItem',
    component: () => import('./components/WorkItem').then(m => m.WorkItem),
    mountPoint: rootRouteRef,
  }),
);
